var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip-container"},[_c('span',{staticClass:"tooltip-target"},[_vm._t("default")],2),_c('div',{staticClass:"tooltip-v"},[(_vm.img)?_c('img',{attrs:{"src":_vm.img},on:{"load":_vm.onImgLoad,"error":_vm.$changeDefaultImage}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }